import {OutputEmitterRef} from "@angular/core";
import {erIkkeTomListe} from "../../støttefunksjoner/lister";

/** Sann dersom det er registrert abonnenter på angitt output */
export function outputAbonnenterRegistrert(output: OutputEmitterRef<any>): boolean {
    return erIkkeTomListe(output['listeners']);
}
